import { produce } from 'immer';

import { UploadImagesInImportWizardInfo } from '../../../actions/importWizardInfo/internal/uploadImagesInImportWizardInfoGrid';
import { ImportWizardInfoState } from '../../../typings/importWizardInfo';

export function uploadImagesInImportWizardInfo(
    state: ImportWizardInfoState,
    action: UploadImagesInImportWizardInfo
): ImportWizardInfoState {
    return produce(state, draft => {
        action.filesToUpload.forEach(file => {
            draft.importImages[file.name] = {
                image: {
                    width: 100,
                    height: 100,
                    name: file.name,
                    url: file.preview || ''
                },
                banners: []
            };
        });
    });
}
